import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import translationES from './locales/es/translation.json';
import translationESCL from './locales/es-CL/translation.json';
import translationESPE from './locales/es-PE/translation.json';
import translationESMX from './locales/es-MX/translation.json';
import translationESCO from './locales/es-CO/translation.json';

const resources = {
  'ES': {
    translation: translationES
  },
  'CHL': {
    translation: translationESCL
  },
  'PER': {
    translation: translationESPE
  },
  'MEX': {
    translation: translationESMX
  },
  'COL': {
    translation: translationESCO
  }
};

i18n.use(initReactI18next).init({
  resources,
  fallbackLng: 'ES',
  interpolation: {
    escapeValue: false
  }
});

export default i18n;
